/* eslint-disable */
if (!Array.from) {
    Array.from = (function () {
        var toStr = Object.prototype.toString;
        var isCallable = function (fn) {
            return typeof fn === "function" || toStr.call(fn) === "[object Function]";
        };
        var toInteger = function (value) {
            var number = Number(value);
            if (isNaN(number)) {
                return 0;
            }
            if (number === 0 || !isFinite(number)) {
                return number;
            }
            return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        var maxSafeInteger = Math.pow(2, 53) - 1;
        var toLength = function (value) {
            var len = toInteger(value);
            return Math.min(Math.max(len, 0), maxSafeInteger);
        };

        // The length property of the from method is 1.
        return function from(arrayLike /*, mapFn, thisArg */ ) {
            // 1. Let C be the this value.
            var C = this;

            // 2. Let items be ToObject(arrayLike).
            var items = Object(arrayLike);

            // 3. ReturnIfAbrupt(items).
            if (arrayLike == null) {
                throw new TypeError(
                    "Array.from requires an array-like object - not null or undefined"
                );
            }

            // 4. If mapfn is undefined, then let mapping be false.
            var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
            var T;
            if (typeof mapFn !== "undefined") {
                // 5. else
                // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                if (!isCallable(mapFn)) {
                    throw new TypeError(
                        "Array.from: when provided, the second argument must be a function"
                    );
                }

                // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                if (arguments.length > 2) {
                    T = arguments[2];
                }
            }

            // 10. Let lenValue be Get(items, "length").
            // 11. Let len be ToLength(lenValue).
            var len = toLength(items.length);

            // 13. If IsConstructor(C) is true, then
            // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
            // 14. a. Else, Let A be ArrayCreate(len).
            var A = isCallable(C) ? Object(new C(len)) : new Array(len);

            // 16. Let k be 0.
            var k = 0;
            // 17. Repeat, while k < len… (also steps a - h)
            var kValue;
            while (k < len) {
                kValue = items[k];
                if (mapFn) {
                    A[k] =
                        typeof T === "undefined" ?
                        mapFn(kValue, k) :
                        mapFn.call(T, kValue, k);
                } else {
                    A[k] = kValue;
                }
                k += 1;
            }
            // 18. Let putStatus be Put(A, "length", len, true).
            A.length = len;
            // 20. Return A.
            return A;
        };
    })();
}

const debounce = (func, wait, immediate) => {
    var timeout;
    return (...args) => {
        const context = this;
        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

/* eslint-enable */
/* eslint-disable linebreak-style */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-use-before-define */

let secondarySliderNode;
let primarySliderNode;
let secondarySlider;
let primarySlider;

let refreshDetailSlider;


document.addEventListener('DOMContentLoaded', () => {
    init();
});

function init() {
    activateCatalogMainPage();

    // TEMP
    hideSelectTown();

    const headerFixed = document.querySelector('.header-fixed');

    if (headerFixed) {
        window.onscroll = () => fixedHeader();
    }

    function fixedHeader() {
        const headerMain = document.querySelector('.header-main');
        const headerPanel = headerMain.querySelector('.h-panel');
        const sticky = headerMain.offsetHeight - headerPanel.offsetHeight;

        if (window.pageYOffset > sticky) {
            headerFixed.classList.add('_active');
        } else {
            headerFixed.classList.remove('_active');
        }
    }

    let mBlockStockAutoplay = false;
    if ($('.m-block-stock__wrapper .swiper-slide').length > 1) {
        mBlockStockAutoplay = {
            delay: 5000,
            disableOnInteraction: false,
        };
    }

    const mySwiperMainStock = new Swiper('.m-block-stock__wrapper', {
        // Optional parameters
        loop: true,

        // If we need pagination
        pagination: {
            el: '.m-block-stock-dots',
            clickable: true,
            bulletClass: 'm-block-stock-dots__item',
            bulletActiveClass: '_active',
        },
        autoplay: mBlockStockAutoplay,
    });

    const swiperMain5Settings = {
        slidesPerView: 4,
        freeMode: true,
        spaceBetween: 0,
        navigation: {
            nextEl: '.similar-products-next',
            prevEl: '.similar-products-prev',
        },
        breakpoints: {
            240: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            380: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            420: {
                slidesPerView: 2,
                spaceBetween: 0,
            },
            880: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
            1100: {
                slidesPerView: 4,
                spaceBetween: 0,
            },
        },
    };

    let swiperMain5 = '';

    if (window.innerWidth > 960) {
        swiperMain5 = new Swiper('#m-swiper-5', swiperMain5Settings);
    }

    window.addEventListener(
        'resize',
        debounce(
            () => {
                if (window.innerWidth <= 960) {
                    if (swiperMain5) {
                        swiperMain5.destroy();
                    }
                } else {
                    swiperMain5 = new Swiper('#m-swiper-5', swiperMain5Settings);
                }
            },
            200,
            false,
        ),
        false,
    );

    secondarySliderNode = document.querySelector('#secondary-slider');
    primarySliderNode = document.querySelector('#primary-slider');

    if (secondarySliderNode && primarySliderNode) {
        secondarySlider = new Splide(secondarySliderNode, {
            rewind: true,
            fixedWidth: 100,
            fixedHeight: 100,
            isNavigation: true,
            gap: 5,
            start: 0,
            arrows: false,
            focus: 'center',
            pagination: false,
            cover: true,
            breakpoints: {
                600: {
                    fixedWidth: 66,
                    fixedHeight: 40,
                },
            },
        }).mount();

        primarySlider = new Splide(primarySliderNode, {
            type: 'fade',
            heightRatio: 1,
            pagination: false,
            arrows: true,
            cover: false,
        });

        // Set the thumbnails slider as a sync target and then call mount.
        primarySlider.sync(secondarySlider).mount();
        lightGallery(document.getElementById('lightgallery'), {
            thumbnail: true,
            download: false,
        });
    }

    refreshDetailSlider = () => {
        if (secondarySliderNode && primarySliderNode) {
            secondarySlider = new Splide(secondarySliderNode, {
                rewind: true,
                fixedWidth: 100,
                fixedHeight: 100,
                isNavigation: true,
                gap: 5,
                start: 0,
                arrows: false,
                focus: 'center',
                pagination: false,
                cover: true,
                breakpoints: {
                    600: {
                        fixedWidth: 66,
                        fixedHeight: 40,
                    },
                },
            }).mount();

            primarySlider = new Splide(primarySliderNode, {
                type: 'fade',
                heightRatio: 1,
                pagination: false,
                arrows: true,
                cover: false,
            });

            // Set the thumbnails slider as a sync target and then call mount.
            primarySlider.sync(secondarySlider).mount();
            lightGallery(document.getElementById('lightgallery'), {
                thumbnail: true,
                download: false,
            });
        }

        lightGallery(document.getElementById('lightgallery'), {
            thumbnail: true,
            download: false,
        });
    };

    refreshDetailSlider();

    function hideSelectTown() {
        const nodes = document.querySelectorAll(
            '.h-panel-nav-select-location__btns-item',
        );
        const btns = Array.from(nodes);
        const container = document.querySelector('.h-panel-nav-select-location');

        btns.forEach((btn) => {
            if (!btn.dataset.click) {
                btn.dataset.click = true;
                btn.addEventListener('click', () => container.classList.remove('_active'));
            }
        });
    }

    function activateCatalogMainPage() {
        const container = document.querySelector('.m-catalog');

        if (container) {
            const tabsNode = container.querySelectorAll('.m-catalog-tabs__item');
            const contentsNode = container.querySelectorAll(
                '.m-catalog-content__root',
            );
            const tabs = Array.from(tabsNode);
            const contents = Array.from(contentsNode);

            tabs.forEach((item, index) => {
                if (!item.dataset.click) {
                    item.dataset.click = true;
                    item.addEventListener('click', () => {
                        tabs.forEach(tab => tab.classList.remove('_selected'));
                        contents.forEach(content => content.classList.remove('_active'));

                        item.classList.add('_selected');
                        contents[index].classList.add('_active');

                        if (index === 0 && swiperMain1) {
                            swiperMain1.update();
                            swiperMain1.navigation.update();
                        }

                        if (index === 1 && swiperMain2) {
                            swiperMain2.update();
                            swiperMain2.navigation.update();
                        }

                        if (index === 2 && swiperMain3) {
                            swiperMain3.update();
                            swiperMain3.navigation.update();
                        }

                        if (index === 3 && swiperMain4) {
                            swiperMain4.update();
                            swiperMain4.navigation.update();
                        }

                        if (index === 4 && swiperMain5) {
                            swiperMain5.update();
                            swiperMain5.navigation.update();
                        }
                    });
                }
            });
        }
    }

    initMenuCatalog();
    listenCheckBoxSaveDataProfile();
    initCatalogBtn();
    initControlsCounter();
    initToggleCatalogViewMode();
    cutUncutDescriptionCatalog();
    listenDeliveryOrderTabs();
    listenDeliveryOrderTabsMobile();
    listenDeliveryBasketTabs();
    listenDeliveryBasketTabsMobile();
    flexibleTextarea('basket-delivery-comment');
    flexibleTextarea('basket-delivery-comment-mobile');
    flexibleTextarea('order-delivery-comment');
    flexibleTextarea('order-delivery-comment-mobile');
    initCatalogOrders();
    initBurgerMenu();
    activateSortFiltersMobile();
    initToggleCatalogViewModeMobile();
}

function initCatalogOrders() {
    $('.catalog-detail-sort-item-select').each(function (index, item) {
        const currentBtn = $(this);

        currentBtn.off('click');
        currentBtn.on('click', () => {
            const currentContent = currentBtn.find('.catalog-detail-sort-item-select__content');

            currentContent.toggle();

            if (currentContent.is(':visible')) {
                const widthContent = currentContent.width();

                currentContent.css('margin-left', `-${widthContent / 2}px`);
            }
        });
        $(document).on('click', (e) => {
            if (!$(e.target).closest(currentBtn.parent()).length) {
                currentBtn.find('.catalog-detail-sort-item-select__content').hide();
            }
            e.stopPropagation();
        });
    });


    $('.catalog-detail-filter-item-select').each(function (index, item) {
        const currentBtn = $(this);

        currentBtn.off('click');
        currentBtn.on('click', () => {
            const currentContent = currentBtn.find('.catalog-detail-filter-item-select__content');

            currentContent.toggle();

            if (currentContent.is(':visible')) {
                const widthContent = currentContent.width();

                currentContent.css('margin-left', `-${widthContent / 2}px`);
            }
        });
        $(document).on('click', (e) => {
            if (!$(e.target).closest(currentBtn.parent()).length) {
                currentBtn.find('.catalog-detail-filter-item-select__content').hide();
            }
            e.stopPropagation();
        });
    });
}

function initMenuCatalog() {
    const appOverlay = document.querySelector('.app-overlay');
    const nodes = document.querySelectorAll('.m-menu-catalog__root');
    const menuItems = Array.from(nodes);
    menuItems.forEach((item) => {
        item.addEventListener('mouseover', () => {
            appOverlay.classList.add('active');
        });
        item.addEventListener('mouseout', () => {
            appOverlay.classList.remove('active');
        });
    });
}


function onClickOpen(container, popup) {
    if (container) {
        container.style.display = 'block';

        scrollPopup(true);
        onClickClose(container, popup);
    }
}

function onClickClose(container, popup) {
    function outsideClickListener(event) {
        if (!popup.contains(event.target) && isVisible(popup)) {
            container.style.display = 'none';
            scrollPopup(false);
            document.removeEventListener('click', outsideClickListener);
        }
    }

    if (container !== null && !container.dataset.click) {
        container.dataset.click = true;
        container.addEventListener('click', outsideClickListener);
    }
}

function isVisible(popup) {
    // открыто ли условное окно
    return (
        !!popup
        && !!(popup.offsetWidth || popup.offsetHeight || popup.getClientRects().length)
    );
}

function scrollPopup(condition) {
    if (condition) {
        document.body.classList.add('_scroll-popup');
    } else {
        document.body.classList.remove('_scroll-popup');
    }
}

function listenCheckBoxSaveDataProfile() {
    const checkBox = document.getElementById('saveDataProfile');
    if (checkBox) {
        const block = document.querySelector('.p-order-no-reg__bg');

        checkBox.addEventListener('change', () => {
            if (checkBox.checked) {
                block.classList.add('_selected');
            } else {
                block.classList.remove('_selected');
            }
        });
    }
}


function initCatalogBtn() {
    const btnCatalog = document.querySelector('.h-btn-catalog__btn');
    const headerContainer = document.querySelector('header.header');
    const appContainer = document.querySelector('.app');

    if (btnCatalog) {
        const menuCatalog = document.querySelector('.h-btn-price-list');
        const menuOverlay = document.querySelector('.menu-overlay');

        if (btnCatalog !== null && !btnCatalog.dataset.click) {
            btnCatalog.dataset.click = true;
            btnCatalog.addEventListener('click', () => {
                if (menuCatalog.classList.contains('_active')) {
                    menuCatalog.classList.remove('_active');
                    menuCatalog.classList.remove('_scroll');
                    menuOverlay.classList.remove('active');
                    fixedBodyScroll(false);
                } else {
                    menuCatalog.classList.add('_active');
                    menuOverlay.classList.add('active');

                    if (
                        appContainer.offsetHeight
                        <= headerContainer.offsetHeight + menuCatalog.offsetHeight
                    ) {
                        fixedBodyScroll(true);
                        menuCatalog.classList.add('_scroll');
                    }
                }
            });
        }

        if (menuOverlay !== null && !menuOverlay.dataset.click) {
            menuOverlay.dataset.click = true;
            menuOverlay.addEventListener('click', () => {
                menuCatalog.classList.remove('_active');
                menuOverlay.classList.remove('active');
            });
        }
    }

    function fixedBodyScroll(condition) {
        if (condition) {
            document.body.classList.add('_fixed-scroll');
        } else {
            document.body.classList.remove('_fixed-scroll');
        }
    }
}

function initControlsCounter() {
    const nodes = document.querySelectorAll('.control-counter');

    if (nodes.length > 0) {
        const controls = Array.from(nodes);

        controls.forEach((control) => {
            const input = control.querySelector('input');
            const controlDecrement = control.querySelector('.control-counter__dec');
            const controlIncrement = control.querySelector('.control-counter__inc');

            if (controlDecrement !== null && !controlDecrement.dataset.click) {
                controlDecrement.dataset.click = true;
                controlDecrement.addEventListener('click', () => {
                    let value = parseInt(input.value, 10);

                    if (value > 1) {
                        value -= 1;
                        input.value = value.toString();
                    }
                });
            }

            if (controlIncrement !== null && !controlIncrement.dataset.click) {
                controlIncrement.dataset.click = true;
                controlIncrement.addEventListener('click', () => {
                    let value = parseInt(input.value, 10);
                    value += 1;

                    input.value = value.toString();
                });
            }
        });
    }
}

function initToggleCatalogViewMode() {
    const viewModeControls = document.querySelectorAll(
        '.catalog-detail-sort__view-mode-item',
    );
    const listContainer = document.querySelectorAll('.catalog-detail-list-block');
    const tilesContainer = document.querySelector('.catalog-detail-tiles-block');

    if (viewModeControls.length > 0) {
        const listItems = Array.from(listContainer);

        viewModeControls.forEach((controlViewMode) => {
            if (!controlViewMode.dataset.click) {
                controlViewMode.dataset.click = true;
                controlViewMode.addEventListener('click', () => {
                    viewModeControls.forEach(item => item.classList.remove('_selected'));

                    controlViewMode.classList.add('_selected');

                    if (controlViewMode.classList.contains('_tiles')) {
                        listItems.forEach(listItem => listItem.classList.remove('_active'));
                        tilesContainer.classList.add('_active');
                    } else {
                        tilesContainer.classList.remove('_active');
                        listItems.forEach(listItem => listItem.classList.add('_active'));
                    }
                });
            }
        });
    }
}

function cutUncutDescriptionCatalog() {
    const catalogDetailContainer = document.querySelector('.catalog-item-detail');
    if (catalogDetailContainer === null) return;

    if (catalogDetailContainer.dataset.cut) return;
    catalogDetailContainer.dataset.cut = true;
    if (catalogDetailContainer) {
        const descNode = document.querySelector('.catalog-item-detail-info__desc');
        const textNode = document.querySelector('.catalog-desc-text');

        if (textNode !== null && descNode !== null) {
            const originalText = textNode.innerText;
            const cutText = truncateDesc(originalText, 450);
            const cutBtn = document.querySelector('.catalog-desc-cut');
            const uncutBtn = document.querySelector('.catalog-desc-uncut');

            if (originalText !== null && originalText.length > cutText.length) {
                descNode.classList.remove('_uncut-text');
                descNode.classList.remove('_hide-btns');
                textNode.innerHTML = cutText;
            } else {
                descNode.classList.add('_hide-btns');
            }

            if (cutText && cutBtn !== null) {
                if (!cutBtn.dataset.click) {
                    cutBtn.dataset.click = true;
                    cutBtn.addEventListener('click', () => {
                        descNode.classList.remove('_uncut-text');
                        textNode.innerHTML = cutText;
                    });
                }
                if (uncutBtn !== null && !uncutBtn.dataset.click) {
                    uncutBtn.dataset.click = true;
                    uncutBtn.addEventListener('click', () => {
                        descNode.classList.add('_uncut-text');
                        textNode.innerHTML = originalText;
                    });
                }
            }
        }
    }
}

function truncateDesc(text, length, clamp) {
    text = text || '';
    clamp = clamp || '';
    length = length || 30;

    if (text.length <= length) return text;

    let tcText = text.slice(0, length - clamp.length);
    let last = tcText.length - 1;

    while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1;

    last = last || length - clamp.length;

    tcText = tcText.slice(0, last);

    return tcText + clamp;
}

function listenDeliveryOrderTabs() {
    const inputs = document.querySelectorAll('input[name="order-delivery"');

    if (inputs.length > 0) {
        const radioBtns = Array.from(inputs);
        const contentNodes = document.querySelectorAll(
            '.order-delivery-content-item',
        );
        const contentItems = Array.from(contentNodes);

        radioBtns.forEach((btn) => {
            if (btn.checked && btn.value === '2') {
                contentItems[0].style.display = 'none';
                contentItems[1].style.display = 'block';
            } else {
                contentItems[0].style.display = 'block';
                contentItems[1].style.display = 'none';
            }

            btn.addEventListener('change', () => {
                if (btn.checked && btn.value === '2') {
                    contentItems[0].style.display = 'none';
                    contentItems[1].style.display = 'block';
                } else {
                    contentItems[0].style.display = 'block';
                    contentItems[1].style.display = 'none';
                }
            });
        });
    }
}

function listenDeliveryOrderTabsMobile() {
    const inputs = document.querySelectorAll(
        'input[name="order-delivery-mobile"',
    );

    if (inputs.length > 0) {
        const radioBtns = Array.from(inputs);
        const contentNodes = document.querySelectorAll(
            '.order-delivery-content-item-mobile',
        );
        const contentItems = Array.from(contentNodes);

        radioBtns.forEach((btn) => {
            if (btn.checked && btn.value === '2') {
                contentItems[0].style.display = 'none';
                contentItems[1].style.display = 'block';
            } else {
                contentItems[0].style.display = 'block';
                contentItems[1].style.display = 'none';
            }

            btn.addEventListener('change', () => {
                if (btn.checked && btn.value === '2') {
                    contentItems[0].style.display = 'none';
                    contentItems[1].style.display = 'block';
                } else {
                    contentItems[0].style.display = 'block';
                    contentItems[1].style.display = 'none';
                }
            });
        });
    }
}

function listenDeliveryBasketTabs() {
    const inputs = document.querySelectorAll('input[name="basket-delivery"');

    if (inputs.length > 0) {
        const radioBtns = Array.from(inputs);
        const contentNodes = document.querySelectorAll(
            '.basket-delivery-content-item',
        );
        const contentItems = Array.from(contentNodes);

        radioBtns.forEach((btn) => {
            if (btn.checked && btn.value === '2') {
                contentItems[0].style.display = 'none';
                contentItems[1].style.display = 'block';
            } else {
                contentItems[0].style.display = 'block';
                contentItems[1].style.display = 'none';
            }

            btn.addEventListener('change', () => {
                if (btn.checked && btn.value === '2') {
                    contentItems[0].style.display = 'none';
                    contentItems[1].style.display = 'block';
                } else {
                    contentItems[0].style.display = 'block';
                    contentItems[1].style.display = 'none';
                }
            });
        });
    }
}

function listenDeliveryBasketTabsMobile() {
    const inputs = document.querySelectorAll(
        'input[name="basket-delivery-mobile"',
    );

    if (inputs.length > 0) {
        const radioBtns = Array.from(inputs);
        const contentNodes = document.querySelectorAll(
            '.basket-delivery-content-item-mobile',
        );
        const contentItems = Array.from(contentNodes);

        radioBtns.forEach((btn) => {
            if (btn.checked && btn.value === '2') {
                contentItems[0].style.display = 'none';
                contentItems[1].style.display = 'block';
            } else {
                contentItems[0].style.display = 'block';
                contentItems[1].style.display = 'none';
            }

            btn.addEventListener('change', () => {
                if (btn.checked && btn.value === '2') {
                    contentItems[0].style.display = 'none';
                    contentItems[1].style.display = 'block';
                } else {
                    contentItems[0].style.display = 'block';
                    contentItems[1].style.display = 'none';
                }
            });
        });
    }
}

function flexibleTextarea(elementName) {
    const txt = document.getElementsByName(elementName)[0];
    const minRows = 1;

    if (txt) {
        setRows();
        txt.rows = minRows;

        txt.onkeyup = () => {
            setRows();
        };
    }

    function setRows() {
        txt.rows = minRows;

        do {
            if (txt.clientHeight !== txt.scrollHeight) {
                txt.rows += 1;
            }
        } while (txt.clientHeight < txt.scrollHeight);
    }
}

function initBurgerMenu() {
    const nodeList = document.querySelectorAll('.burger-menu__item');

    if (nodeList.length > 0) {
        const burgerItems = Array.from(nodeList);

        burgerItems.forEach((item) => {
            if (!item.dataset.click) {
                item.dataset.click = true;
                item.addEventListener('click', () => {
                    if (item.classList.contains('_active')) {
                        item.classList.remove('_active');
                    } else {
                        item.classList.add('_active');
                    }
                });
            }
        });
    }
}

function initToggleCatalogViewModeMobile() {
    const viewModeControls = document.querySelectorAll(
        '.filter-panel-mobile-btn',
    );
    const listContainer = document.querySelectorAll('.catalog-detail-list-block');
    const tilesContainer = document.querySelector('.catalog-detail-tiles-block');

    if (viewModeControls.length > 0) {
        const listItems = Array.from(listContainer);

        viewModeControls.forEach((controlViewMode) => {
            if (!controlViewMode.dataset.click) {
                controlViewMode.dataset.click = true;
                controlViewMode.addEventListener('click', () => {
                    if (!controlViewMode.classList.contains('_filter-pop')) {
                        viewModeControls.forEach(item => item.classList.remove('_selected'));

                        controlViewMode.classList.add('_selected');

                        tilesContainer.classList.remove('_active');
                        listItems.forEach(listItem => listItem.classList.add('_active'));
                    }
                });
            }
        });
    }
}

function activateSortFiltersMobile() {
    const nodes = document.querySelectorAll('.filter-panel-mobile-sort');

    if (nodes.length > 0) {
        const sortFilters = Array.from(nodes);

        sortFilters.forEach((sortFilter) => {
            if (sortFilter) {
                if (!sortFilter.dataset.click) {
                    sortFilter.dataset.click = true;
                    sortFilter.addEventListener('click', (e) => {
                        const {
                            target,
                        } = e;

                        sortFilters.forEach((item) => {
                            if (target === item) {
                                if (item.classList.contains('_active')) {
                                    item.classList.remove('_active');
                                } else {
                                    item.classList.add('_active');
                                }
                            } else {
                                item.classList.remove('_active');
                            }
                        });
                    });
                }

                const titleContainer = sortFilter.querySelector(
                    '.filter-panel-mobile-sort__title ._current-item',
                );
                const radioBtnNodes = sortFilter.querySelectorAll(
                    '.filter-panel-mobile-sort-item',
                );
                const radioBtns = Array.from(radioBtnNodes);

                radioBtns.forEach((radioBtn) => {
                    const input = radioBtn.querySelector('.radio__input');
                    const textContainer = radioBtn.querySelector('.radio__content');
                    const text = textContainer.textContent.trim();

                    if (input.checked) {
                        titleContainer.textContent = text;
                    }

                    input.addEventListener('change', () => {
                        if (input.checked) {
                            titleContainer.textContent = text;
                        }
                    });
                });
            }
        });
    }
}

window.init = init;